/// <reference path="../../types.d.ts" />
import { authenticationChannel } from '@codametrix/ui-common';
import { connect } from 'react-redux';
import { activeProcessId, getBPMDetails } from '../../actions/bpm-steps.action';
import { buildDispatchable } from '../../actions/_action-utilities';
import { BPMStepsApp } from './bpm-steps-app';
import { broadcastWindowActivity } from '../../core/session-activity';

const mapStateToProps = function(state: any) {
  return {
    ...state.steps
  };
};

const mapDispatchToProps = (dispatch: any) => {
  const runDispatchable = buildDispatchable(dispatch);
  return {
    registerActivity: broadcastWindowActivity,
    getBPMDetails: async (urlParams: any) => {
      await authenticationChannel.ready;
      runDispatchable(() => {
        return dispatch(getBPMDetails(urlParams));
      });
    },
    setActiveProcessId: (processId: number) => {
      dispatch(activeProcessId(processId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BPMStepsApp);
